import { IAuthForgottenPassChange } from "@api/auth.int";
import { Alert, AlertDescription, AlertIcon, Box, FormControl, FormLabel, Input, useBoolean } from "@chakra-ui/react";
import { useDeepAuth, useVVApi } from "components/api";
import { DeepErrorBox } from "components/misc";
import { VizvButtonPrimary, VizvCard, VizvCardActionStrip, VizvCardContent, VizvCardHeader, VizvMainCol } from "components/vizvComponents";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import { getGReCaptcha } from "./DeepAuth";


export function UserForgottenPassChange() {

	const api = useVVApi();
	const auth = useDeepAuth();
	const params = useParams();
	const paramsToken = params.token || '';
	const nav = useNavigate();
	const loc = useLocation();
	const isAckEmail = loc.pathname.startsWith('/user/first-password/');

	useEffect(() => {
		if (!paramsToken)
			setError('Missing params token!');
	}, [paramsToken]);


	const onSubmit = async (e: React.SyntheticEvent) => {
		e.preventDefault();
		setIsLoading.on();
		setError('');

		const target = e.target as typeof e.target & {
			password: { value: string };
			passwordAgain: { value: string };
		};
		const password = target.password.value;
		const passwordAgain = target.passwordAgain.value;

		if (password != passwordAgain) {
			setError('Nem stimmel a két jelszó!');
			return;
		}
		try {
			const grecaptchaToken = await getGReCaptcha();
			const resp = await api.fetch<IAuthForgottenPassChange>({
				url: '/auth/forgotten-pass-change',
				method: 'POST',
				payload: {
					grecaptchaToken, confirmToken: paramsToken, newPassword: password
				}
			});
			auth.signOut();
			nav('/map');
			auth.showSignIn('Jelszavadat megváltoztattuk, jelentkezz be!');
		} catch (ex) {
			setError('' + ex);
		} finally {
			setIsLoading.off();
		}
	}

	const [isLoading, setIsLoading] = useBoolean();
	const [error, setError] = useState('');

	const title = isAckEmail ? 'Üdvözlet vízvédő!' : 'Jelszó megváltoztatása';
	const buttonText = isAckEmail ? 'Jelszó beállítása' : 'Jelszó megváltoztatása'

	return <VizvMainCol>
		<VizvCard isClosable>
			<DeepErrorBox isLoading={isLoading} error={error} />
			<VizvCardHeader >{title}</VizvCardHeader>
			<form onSubmit={onSubmit}>

				<VizvCardContent  >
					{isAckEmail && <Box>
						Köszönjük a bejelentésed!<br />
						Csatlakozz kérlek hozzánk, állíts be egy jelszót, hogy be tudj jelentkezni!

					</Box>}

					<fieldset disabled={isLoading}>
						<FormControl>
							<FormLabel>Jelszó</FormLabel>
							<Input type='password' autoComplete="new-password" name='password' />
						</FormControl>
						<FormControl>
							<FormLabel>Jelszó még egyszer</FormLabel>
							<Input type='password' autoComplete="new-password" name='passwordAgain' />
						</FormControl>
					</fieldset>

				</VizvCardContent>
				<VizvCardActionStrip>
					<VizvButtonPrimary type='submit' isLoading={isLoading} ml='auto' protLev="any" >
						{buttonText}
					</VizvButtonPrimary>
				</VizvCardActionStrip>


			</form>
		</VizvCard>
	</VizvMainCol>







}